import { IPersonalInfoCMS } from '@vfit/consumer/data-access';

export const organizeEditNumber = (dataFromCms: IPersonalInfoCMS) => ({
  title: dataFromCms?.personalinfo?.clientLogged?.editNumber?.title || '',
  titleNew: dataFromCms?.personalinfo?.clientLogged?.newNumber?.title || '',
  subtitle: dataFromCms?.personalinfo?.clientLogged?.newNumber?.description || '',
  buttonText: dataFromCms?.personalinfo?.clientLogged?.newNumber?.buttonLabel || '',
  lable: dataFromCms?.personalinfo?.selectInput?.telephone || '',
});
